import { render, staticRenderFns } from "./Preset.vue?vue&type=template&id=67361125&scoped=true&"
import script from "./Preset.vue?vue&type=script&lang=js&"
export * from "./Preset.vue?vue&type=script&lang=js&"
import style0 from "./Preset.vue?vue&type=style&index=0&id=67361125&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67361125",
  null
  
)

export default component.exports